// extracted by mini-css-extract-plugin
export default {"headwayNotification":"styles_headwayNotification__58EEz","indicatorNew":"styles_indicatorNew__Gg4lf","headwayWidget":"styles_headwayWidget__qzFsd","label":"styles_label__EwwSJ"};